import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import { useRtRecommendQuery } from "@/hooks";
const RECOMMEND_PAGE_LIMIT = 5;

export default function RtRecommendList({ elementId, header }) {
  const { data, ...result } = useRtRecommendQuery({
    variables: {
      location: `${window.location.origin}${window.location.pathname}`,
      elementIds: [elementId],
    },
    fetchPolicy: "cache-first",
  });

  if (!data?.recommend) return null;

  const items = data?.recommend.find((data) => data.elementId === elementId);

  return (
    <List
      {...result}
      itemComponent={ListRow}
      header={header}
      items={items}
      limit={RECOMMEND_PAGE_LIMIT}
      viewTypeClassName="list"
      loadMore={false}
    />
  );
}
